(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-data/assets/javascripts/actions/receive-message.js') >= 0) return;  svs.modules.push('/components/chat/chat-data/assets/javascripts/actions/receive-message.js');
'use strict';

const _excluded = ["chatRoomId", "user", "created", "timestamp", "isAuthorOfMessage", "status", "clientToken"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const CHAT_RECEIVE_MESSAGE = 'CHAT/CHAT_RECEIVE_MESSAGE';
const _svs$components$chat$ = svs.components.chat.chatData,
  log = _svs$components$chat$.log,
  constants = _svs$components$chat$.constants,
  helpers = _svs$components$chat$.helpers;
const socketReceiveMessage = (roomId, response) => (dispatch, getState) => {
  log.debug("Socket receive message (error: ".concat(!!response.error, ")"));
  if (!response.error && response.result) {
    log.debug("Socket receive messageId ".concat(response.result.message.id));
    const _response$result$mess = response.result.message,
      chatRoomId = _response$result$mess.chatRoomId,
      user = _response$result$mess.user,
      created = _response$result$mess.created,
      timestamp = _response$result$mess.timestamp,
      isAuthorOfMessage = _response$result$mess.isAuthorOfMessage,
      serverStatus = _response$result$mess.status,
      clientToken = _response$result$mess.clientToken,
      messageData = _objectWithoutProperties(_response$result$mess, _excluded);
    const chatState = getState().Chat,
      customerId = chatState.customerId,
      messageIsInState = (chatState.messages[roomId] || []).find(msg => msg.id === messageData.id);

    if (messageIsInState && serverStatus === constants.SERVER_MESSAGE_STATUS_ORIGINAL) {
      log.debug("New message not dispatched already in store, messageId: ".concat(messageData.id));
      return;
    }

    if (!messageIsInState && serverStatus !== constants.SERVER_MESSAGE_STATUS_ORIGINAL) {
      return;
    }
    dispatch({
      type: CHAT_RECEIVE_MESSAGE,
      roomId,
      increaseUnreadCount: serverStatus === constants.SERVER_MESSAGE_STATUS_ORIGINAL && !chatState.isOpen ? 1 : 0,
      clientToken: customerId === user.id ? clientToken : null,
      messageData: helpers.formatMessage(_objectSpread(_objectSpread({}, response.result.message), {}, {
        isAuthorOfMessage: customerId === user.id,
        isRetailer: user.isEditor
      }))
    });
  }
};
setGlobal('svs.components.chat.chatData.actions', {
  socketReceiveMessage,
  CHAT_RECEIVE_MESSAGE
});

 })(window);